"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const page_section_1 = __importDefault(require("~components/page-section"));
const styled_1 = require("./styled");
const ui_1 = require("@phishtool/ui");
const iconHeight = 72;
const iconMap = {
    ingestion: {
        name: 'email-ingestion',
        width: 82,
    },
    console: {
        name: 'forensic-console',
        width: 63,
    },
    parsing: {
        name: 'parsing',
        width: 83,
    },
    reporting: {
        name: 'reporting',
        width: 68,
    },
};
const HowDoesPhishToolWorkItem = ({ type, title, description }) => {
    const icon = iconMap[type];
    return ((0, jsx_runtime_1.jsxs)(ui_1.Flex, { align: "center", gap: "x3", children: [(0, jsx_runtime_1.jsx)(styled_1.StyledIconWrapper, { children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: icon.name, size: { width: icon.width, height: iconHeight }, color: "silverPearl" }) }), (0, jsx_runtime_1.jsxs)(ui_1.Flex, { direction: "column", flex: 1, children: [(0, jsx_runtime_1.jsx)(ui_1.Paragraph, { fontWeight: "bold", spacer: "x0", children: title }), (0, jsx_runtime_1.jsx)(ui_1.Paragraph, { spacer: "x0", children: description })] })] }));
};
const HowDoesPhishToolWork = ({ title, intro, items }) => ((0, jsx_runtime_1.jsx)(page_section_1.default, { id: "how", headerSpacer: ['x3', null, 'x9'], title: title, intro: intro, children: (0, jsx_runtime_1.jsx)(ui_1.Flex, { justify: "center", children: (0, jsx_runtime_1.jsx)(styled_1.StyledItemsWrapper, { children: items.map((item) => ((0, jsx_runtime_1.jsx)(HowDoesPhishToolWorkItem, Object.assign({}, item), item.type))) }) }) }));
exports.default = HowDoesPhishToolWork;
